import React from 'react';
import { experience } from '../data';

function Experience() {
  return (
    <section className="section" id="experience">
      <div className="section-head reveal">
        <span className="eyebrow">
          <i className="fa-solid fa-briefcase"></i> Experience
        </span>
        <h2 className="section-title">
          Where I've <span className="gradient-text">worked</span>
        </h2>
        <p className="section-sub">
          Building products full-time, and delivering for clients on the side.
        </p>
      </div>

      <div className="timeline">
        {experience.map((job) => (
          <div key={job.company} className="tl-item reveal">
            <div className="tl-card card">
              <span className="tl-tag">{job.type}</span>
              <div className="tl-top">
                <div>
                  <span className="tl-role">{job.role}</span>
                  {' · '}
                  <span className="tl-company">{job.company}</span>
                </div>
                <span className="tl-period">{job.period}</span>
              </div>
              {job.project && (
                <div className="tl-project">
                  <i className="fa-solid fa-diagram-project"></i> {job.project}
                </div>
              )}
              <ul className="tl-points">
                {job.points.map((p, idx) => (
                  <li key={idx}>{p}</li>
                ))}
              </ul>
              {job.stack && (
                <div className="tech-row tl-stack">
                  {job.stack.map((t) => (
                    <span key={t} className="tech-pill">
                      {t}
                    </span>
                  ))}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Experience;
